// Third-party
import React from 'react';

// Utils
import { formatMessage } from '@/utils/i18n';

// Images
import { ReactComponent as CsvIcon } from '@/images/csv-icon.svg?react';

type Props = {
  file?: File;
};

const ImportStep: React.FC<Props> = ({ file }) => (
  <div className="file-uploader-import-step">
    <div className="file-uploader-progress-wrapper">
      <div className="file-uploader-progress">
        <CsvIcon className="file-uploader-csv-icon" />
        <div className="mt-3">
          {formatMessage('Modal.PortfolioUpload.SuccessfullyUploaded')}
          <br />
          {formatMessage('Modal.PortfolioUpload.FileReady')}
        </div>

        <div className="file-uploader-progress-file-name">
          <i className="icon-circle-checkmark me-2" /> {file?.name}
        </div>
      </div>
    </div>
  </div>
);

export default ImportStep;
